import { render } from "./Footer.vue?vue&type=template&id=67d2d3fc&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=67d2d3fc&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d2d3fc"]])

export default __exports__